import React, { useState } from 'react';
import {
  CheckCircle2,
  XCircle,
  RefreshCw,
  Layers,
  FileCode,
  User,
  Activity,
  Camera,
  Map,
  Shield,
  Clock,
  GitBranch,
  CheckSquare,
  Database,
  ChevronDown,
  ChevronUp
} from 'lucide-react';

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// ReviewGate
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const ReviewGate = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');

  const handleReject = () => {
    if (rejectReason.trim()) {
      onReject(rejectReason);
      setShowRejectModal(false);
      setRejectReason('');
    }
  };

  if (execution.status === 'approved') {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-green-700">
          <CheckCircle2 className="w-5 h-5" />
          <span className="font-medium">Execution approvata</span>
        </div>
      </div>
    );
  }

  if (execution.status === 'rejected') {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-red-700">
          <XCircle className="w-5 h-5" />
          <span className="font-medium">Execution rigettata</span>
        </div>
        {execution.rejectionReason && (
          <p className="text-sm text-red-600 mt-2">{execution.rejectionReason}</p>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h3 className="font-medium text-gray-800 mb-3">Revisiona Output</h3>
        <div className="flex gap-3">
          <button onClick={() => onApprove()} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50">
            <CheckCircle2 className="w-4 h-4" /> Approva
          </button>
          <button onClick={onRegenerate} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50">
            <RefreshCw className="w-4 h-4" /> Rigenera
          </button>
          <button onClick={() => setShowRejectModal(true)} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50">
            <XCircle className="w-4 h-4" /> Rigetta
          </button>
        </div>
      </div>

      {showRejectModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <h3 className="text-lg font-semibold mb-4">Motivo del Rigetto</h3>
            <textarea value={rejectReason} onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Spiega perchÃ© rigetti questa execution..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
              rows={4} />
            <div className="flex gap-3 mt-4">
              <button onClick={() => setShowRejectModal(false)}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                Annulla
              </button>
              <button onClick={handleReject} disabled={!rejectReason.trim()}
                className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50">
                Conferma Rigetto
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// IRLayerCard â€” collapsible layer with JSON content
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const IRLayerCard = ({ icon: Icon, title, data, colorClass, bgClass, borderClass, defaultOpen = false }) => {
  const [expanded, setExpanded] = useState(defaultOpen);
  if (!data || (typeof data === 'object' && !Object.keys(data).length)) return null;

  const isEmpty = typeof data === 'object' && Object.keys(data).length === 0;
  if (isEmpty) return null;

  return (
    <div className={`rounded-lg border ${borderClass} overflow-hidden`}>
      <button onClick={() => setExpanded(!expanded)}
        className={`w-full flex items-center justify-between p-3 ${bgClass} hover:opacity-90 transition-opacity`}>
        <div className="flex items-center gap-2">
          <Icon className={`w-4 h-4 ${colorClass}`} />
          <span className={`text-xs font-semibold uppercase tracking-wide ${colorClass}`}>{title}</span>
        </div>
        {expanded
          ? <ChevronUp className={`w-4 h-4 ${colorClass} opacity-50`} />
          : <ChevronDown className={`w-4 h-4 ${colorClass} opacity-50`} />}
      </button>
      {expanded && (
        <div className="bg-white border-t border-gray-100 p-4">
          <pre className="text-xs text-gray-700 overflow-x-auto whitespace-pre-wrap break-words leading-relaxed">
            {JSON.stringify(data, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// SpecHeader â€” layer count summary
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const SpecHeader = ({ spec = {}, renderMetadata = {} }) => {
  const populatedLayers = Object.entries(spec).filter(([, v]) =>
    v && typeof v === 'object' && Object.keys(v).length > 0
  ).length;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 space-y-2">
      <div className="flex items-center justify-between">
        <p className="text-xs font-medium text-blue-500 uppercase tracking-wide">Video Generation Specification</p>
        <span className="text-xs font-bold text-blue-700 bg-blue-100 border border-blue-200 rounded-full px-2.5 py-0.5">
          {populatedLayers} / 10 layers
        </span>
      </div>
      {renderMetadata && Object.keys(renderMetadata).length > 0 && (
        <div className="flex flex-wrap gap-3 mt-1">
          {Object.entries(renderMetadata).slice(0, 4).map(([key, val]) => (
            <div key={key}>
              <span className="text-xs text-blue-400 capitalize">{key.replace(/_/g, ' ')}: </span>
              <span className="text-xs text-blue-700 font-medium">{String(val)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// Layer config
const LAYERS = [
  { key: 'execution_graph',   icon: GitBranch,  title: 'Execution Graph',   color: 'text-blue-600',   bg: 'bg-blue-50',   border: 'border-blue-200' },
  { key: 'script_layer',      icon: FileCode,   title: 'Script Layer',      color: 'text-green-600',  bg: 'bg-green-50',  border: 'border-green-200' },
  { key: 'identity_layer',    icon: User,       title: 'Identity Layer',    color: 'text-purple-600', bg: 'bg-purple-50', border: 'border-purple-200' },
  { key: 'motion_layer',      icon: Activity,   title: 'Motion Layer',      color: 'text-violet-600', bg: 'bg-violet-50', border: 'border-violet-200' },
  { key: 'rendering_layer',   icon: Camera,     title: 'Rendering Layer',   color: 'text-indigo-600', bg: 'bg-indigo-50', border: 'border-indigo-200' },
  { key: 'environment_layer', icon: Map,        title: 'Environment Layer', color: 'text-teal-600',   bg: 'bg-teal-50',   border: 'border-teal-200' },
  { key: 'constraint_layer',  icon: Shield,     title: 'Constraint Layer',  color: 'text-red-600',    bg: 'bg-red-50',    border: 'border-red-200' },
  { key: 'timing_layer',      icon: Clock,      title: 'Timing Layer',      color: 'text-amber-600',  bg: 'bg-amber-50',  border: 'border-amber-200' },
  { key: 'dependency_graph',  icon: Layers,     title: 'Dependency Graph',  color: 'text-gray-600',   bg: 'bg-gray-50',   border: 'border-gray-200' },
  { key: 'validation_hooks',  icon: CheckSquare,title: 'Validation Hooks',  color: 'text-cyan-600',   bg: 'bg-cyan-50',   border: 'border-cyan-200' },
];

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Contract16View â€” main component
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export default function Contract16View({ execution, onApprove, onReject, onRegenerate, loading }) {
  if (!execution) {
    return (
      <div className="flex items-center justify-center h-64 text-gray-400">
        <p>Nessuna execution selezionata</p>
      </div>
    );
  }

  const output = execution.output || execution.outputData || {};
  const spec = output.video_generation_specification || {};
  const renderMetadata = output.render_metadata || {};
  const temporalRenderData = output.temporal_render_data || {};

  return (
    <div className="h-full overflow-y-auto">
    <div className="space-y-4 max-w-4xl mx-auto p-6">

      {/* Header */}
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <div className="flex items-start justify-between">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Contract 16 â€” Video Generation Specification</h2>
            <p className="text-sm text-gray-500 mt-0.5">Specification Composer â€” Intermediate Representation Layer</p>
          </div>
          <div className="flex items-center gap-2">
            {execution.status === 'approved' && (
              <span className="flex items-center gap-1 text-xs font-medium text-green-700 bg-green-50 border border-green-200 rounded-full px-2.5 py-1">
                <CheckCircle2 className="w-3.5 h-3.5" /> Approvato
              </span>
            )}
            {execution.status === 'rejected' && (
              <span className="flex items-center gap-1 text-xs font-medium text-red-700 bg-red-50 border border-red-200 rounded-full px-2.5 py-1">
                <XCircle className="w-3.5 h-3.5" /> Rigettato
              </span>
            )}
            {execution.status === 'completed' && (
              <span className="flex items-center gap-1 text-xs font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-full px-2.5 py-1">
                <Layers className="w-3.5 h-3.5" /> Completato
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Review gate */}
      <ReviewGate
        execution={execution}
        onApprove={onApprove}
        onReject={onReject}
        onRegenerate={onRegenerate}
        loading={loading}
      />

      {/* Spec summary */}
      {Object.keys(spec).length > 0 && (
        <SpecHeader spec={spec} renderMetadata={renderMetadata} />
      )}

      {/* IR Layers */}
      {LAYERS.map(({ key, icon, title, color, bg, border }) => (
        <IRLayerCard
          key={key}
          icon={icon}
          title={title}
          data={spec[key]}
          colorClass={color}
          bgClass={bg}
          borderClass={border}
          defaultOpen={key === 'script_layer'}
        />
      ))}

      {/* Temporal render data */}
      {Object.keys(temporalRenderData).length > 0 && (
        <IRLayerCard
          icon={Database}
          title="Temporal Render Data"
          data={temporalRenderData}
          colorClass="text-gray-600"
          bgClass="bg-gray-50"
          borderClass="border-gray-200"
        />
      )}

    </div>
    </div>
  );
}
